export default "__VITE_ASSET__CTVQP2yO__"